import React, { useState } from "react";
import DayTimetable from "../../Components/dayTimetable";
import DateSelector from "../../Components/dateSelector";
import ScholWeekSelector from "../../Components/schoolWeekSelector";
import ClassStatsGrid from "../../Components/classStatsGrid";
import { Toggle } from "@carbon/react";
import { useSearchParams } from "react-router-dom";

export default function TeacherClassStats({ selectedClass }) {

    const [searchParams, setSearchParams] = useSearchParams();
    const [schoolWeek, setSchoolWeek] = useState(() => {
        const weekParam = searchParams.get('week');
        if (weekParam === null) {
            console.warn("No week parameter found, defaulting to 0");
            return null;
        }
        const week = parseInt(weekParam, 10);
        return isNaN(week) ? null : week;
    });


    function schoolWeekChange(weekNumber) {
        setSchoolWeek(weekNumber);
        const params = { ...Object.fromEntries(searchParams) };
        params.week = weekNumber.toString();
        setSearchParams(params);
    }

    if (!selectedClass) {
        return (
            <section className="container mx-auto">
                <p className="text-gray-600 mb-4">
                    Keine Klasse ausgewählt
                </p>
            </section>
        );
    }

    return (
        <section className="container mx-auto">
            <div className="my-6 flex justify-between items-center space-x-4">
                <div className="flex font-semibold text-xl">
                    <span>Statistiken </span>
                </div>
                <ScholWeekSelector
                    selectedWeek={schoolWeek}
                    onWeekChange={schoolWeekChange}
                />
            </div>
            <div className="">
                <ClassStatsGrid selectedClass={selectedClass} weekIndex={schoolWeek} />
            </div>
        </section>
    );
}
